import React from "react";
import "./footer.css";

export default function footer() {
  return (
    <div className="footer">
      <div className="line"></div>
      <div className="contenido-footer">
        <div className="parrafo">
          A través de una intensa búsqueda de colores e ideas que buscan cambiar
          los esquemas personales de los espectadores de su obra, Rafael Merino
          Orea, quien cuenta con 48 años de trayectoria artística, se ha
          convertido en uno de los pintores más prestigiados de nuestro país
          gracias a la perfecta definición del cuerpo humano plasmada en sus
          lienzos.
        </div>
        <div className="social">
          <a className="fab fa-facebook" href="https://www.facebook.com/profile.php?id=100008333384244"></a>
          <a className="fab fa-instagram" href="https://instagram.com/rafael_merinoo?igshid=YmMyMTA2M2Y="></a>
        </div>
      </div>
    </div>
  );
}
